import React  from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useChangeLangugeMutation } from "../../app/features/apiSlice";
import { toastError, toastSuccess } from "../../helpers";
import "react-phone-number-input/style.css";
import { Formik } from "formik";

const SelectLanguage = ({ data, refetch }) => {
  const { t } = useTranslation();

  const initialValues = {
    language: data?.user?.language || "en",  
  };

  const [changeLanguge] = useChangeLangugeMutation();

  const handleSubmit = async (values) => {
    try {
      const response = await changeLanguge({
        data: values,
      });
      if (response?.error) {
        toastError(response, t("error.serverNotResponding"));
      } else {
        const message = response?.data?.msg ?? response?.data?.message;
        toastSuccess(message);
        refetch(); 
      }
    } catch (err) {
      toastError(err, t("error.serverNotResponding"));
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => handleSubmit(values)}
    >
      {({
        handleSubmit,
        handleChange,
        values,
        errors,
        touched,
      }) => (
        <Form noValidate onSubmit={handleSubmit} className="add-inner-form pt-3">
          <Form.Group as={Row} className="mb-3">
            <Col sm={10}>
              <Form.Group className="mb-3">
                <Form.Check
                  type="radio"
                  label={t("english")}
                  name="language"
                  value="en"
                  checked={values.language === "en"} 
                  onChange={handleChange}
                />
                <Form.Check
                  type="radio"
                  name="language"
                  label={t("italian")}
                  value="it"
                  checked={values.language === "it"} 
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Form.Group>
          <Button variant="primary-outline" type="submit">
            {t("update")}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default SelectLanguage;
